export default "__VITE_ASSET__P4DPfwIRieI8P6q8r4JZRw__"